import React from 'react';
import { DownloadIcon } from 'lucide-react';
export function DownloadBallot() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1328">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-10" data-id="element-1329">
        <div className="flex items-center gap-4 p-5 rounded-xl border-2" style={{
        backgroundColor: '#fffbeb',
        borderColor: '#c8a84b'
      }} data-id="element-1330">
          <div className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-1331">
            <DownloadIcon size={22} style={{
            color: '#c8a84b'
          }} data-id="element-1332" />
          </div>
          <div className="flex-1" data-id="element-1333">
            <h3 className="text-lg font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1334">
              Download the 2026 FLSC Ballot and Letter
            </h3>
            <p className="text-sm text-gray-600 mt-0.5" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1335">
              Print and mail your absentee ballot if you cannot attend in
              person.
            </p>
          </div>
          <a href="https://www.fentonlakes.com/uploaded/files/FLSC%202026%20Election%20Letter%20and%20Ballot.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-5 py-3 rounded-lg text-sm font-bold uppercase tracking-wider transition-opacity hover:opacity-90 flex-shrink-0" style={{
          backgroundColor: '#1e3d2f',
          color: '#ffffff',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-1336">
            <DownloadIcon size={16} data-id="element-1337" />
            Download PDF
          </a>
        </div>
      </div>
    </div>;
}